import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCard = ({ 
  title,
  value,
  change,
  changeType = 'positive',
  icon,
  iconColor = 'var(--color-primary)',
  description,
  className = ''
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      className={`
        bg-card rounded-xl border-none shadow-warm p-4 md:p-6
        hover:shadow-warm-md transition-all duration-250
        ${className}
      `}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground font-caption mb-1">
            {title}
          </p>
          {value && (
            <h4 className="text-2xl md:text-3xl font-semibold text-foreground font-heading">
              {value}
            </h4>
          )}
        </div>
        <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-muted flex items-center justify-center">
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>

      {change && change !== 0 && (
        <div className="flex items-center gap-2">
          <div className={`flex items-center gap-1 ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={16} />
            <span className="text-sm font-semibold font-caption">{change}</span>
          </div>
          {description && (
            <span className="text-xs text-muted-foreground font-caption">
              {description}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default QuickStatsCard;